import axios from 'axios';
import config from '../config/config';

class ScopeApi {
    static loadSmallScope() {
        return axios.get(`${config.server.endpoint}backend/scope/small`)
    }

    static loadFullScope() {
        return axios.get(`${config.server.endpoint}backend/scope/full`)
    }
}

export default ScopeApi;
